"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _awsSdk = _interopRequireDefault(require("aws-sdk"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _semanticUiReact = require("semantic-ui-react");

var _reactStripeElements = require("react-stripe-elements");

var _DomainSearchForm = _interopRequireDefault(require("./DomainSearchForm"));

var _PaymentOptions = _interopRequireDefault(require("./PaymentOptions"));

var _CheckoutForm = _interopRequireDefault(require("./CheckoutForm"));

var _Completion = _interopRequireDefault(require("./Completion"));

var _EmailService = _interopRequireDefault(require("../utils/EmailService"));

var _EmailSubmitService = _interopRequireDefault(require("../utils/EmailSubmitService"));

var _subscriptionPlans = _interopRequireDefault(require("../data/subscription-plans"));

var _PeriodSelect = _interopRequireDefault(require("./PeriodSelect"));

var _paymentTypes = require("../data/payment-types");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var PublishModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PublishModal, _React$Component);

  var _super = _createSuper(PublishModal);

  function PublishModal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PublishModal);
    _this = _super.call(this, props);
    _this.state = {
      currentDomain: null,
      enteredDomain: '',
      customDomain: null,
      customDomainInputError: false,
      hasCustomDomain: false,
      currentPlanIndex: null,
      currentPlanPeriod: null,
      email: '',
      emailSubmitted: false
    };
    _this.stripeApiKey = process.env.STRIPE_API_KEY || process.env.STORYBOOK_STRIPE_API_KEY;
    _this.handleDomainChange = _this.handleDomainChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDomainSelected = _this.onDomainSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onHasCustomDomainChanged = _this.onHasCustomDomainChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCustomDomainSelected = _this.onCustomDomainSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPlanSelected = _this.onPlanSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPeriodSelected = _this.onPeriodSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmailChange = _this.handleEmailChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSubmitEmail = _this.onSubmitEmail.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PublishModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _awsSdk["default"].config.update({
        region: 'us-east-1',
        credentials: new _awsSdk["default"].Credentials(process.env.AWS_ACCESS_KEY_ID, process.env.AWS_SECRET_ACCESS_KEY)
      });
    }
  }, {
    key: "onDomainSelected",
    value: function onDomainSelected(newDomain) {
      var _this2 = this;

      this.setState({
        currentDomain: newDomain
      }, function () {
        var currentDomain = _this2.state.currentDomain;
        var business = _this2.props.business;
        var name = business.name;
        var subject = "Domain Selected - ".concat(name);
        var content = "".concat(name, " has selected their domain through our payment flow system. \n      It needs to be linked to their new website. Their domain is: ").concat(currentDomain.DomainName);
        (0, _EmailService["default"])({
          businessName: name,
          subject: subject,
          content: content
        });
      });
      this.logEvent('Domain Selected');
    }
  }, {
    key: "onCustomDomainSelected",
    value: function onCustomDomainSelected(newCustomDomain) {
      var _this3 = this;

      if (newCustomDomain === null) {
        this.setState({
          customDomain: newCustomDomain,
          currentDomain: newCustomDomain
        });
      }

      if (newCustomDomain.length > 3) {
        this.setState({
          customDomain: newCustomDomain,
          currentDomain: newCustomDomain,
          customDomainInputError: false
        }, function () {
          var customDomain = _this3.state.customDomain;
          var business = _this3.props.business;
          var name = business.name;
          var subject = "Link Custom Domain - ".concat(name);
          var content = "".concat(name, " has entered their custom domain through our payment flow system. \n        It needs to be linked to their new website. Their custom domain is: ").concat(customDomain);
          (0, _EmailService["default"])({
            businessName: name,
            subject: subject,
            content: content
          });
        });
      } else {
        this.setState({
          customDomainInputError: true
        });
      }

      this.logEvent('Existing Domain Selected');
    }
  }, {
    key: "onHasCustomDomainChanged",
    value: function onHasCustomDomainChanged() {
      this.setState(function (_ref) {
        var hasCustomDomain = _ref.hasCustomDomain;
        return {
          hasCustomDomain: !hasCustomDomain
        };
      });
    }
  }, {
    key: "onPlanSelected",
    value: function onPlanSelected(newPlanIndex) {
      this.setState({
        currentPlanIndex: newPlanIndex
      });
      this.logEvent('Payment Plan Selected');
    }
  }, {
    key: "onPeriodSelected",
    value: function onPeriodSelected(newStatus) {
      this.setState(function () {
        return {
          currentPlanPeriod: newStatus
        };
      });
      this.logEvent('Plan Period Selected');
    }
  }, {
    key: "handleDomainChange",
    value: function handleDomainChange(e, _ref2) {
      var value = _ref2.value;
      this.setState({
        enteredDomain: value
      });
    }
  }, {
    key: "handleEmailChange",
    value: function handleEmailChange(e, _ref3) {
      var value = _ref3.value;
      this.setState({
        email: value
      });
    }
  }, {
    key: "onSubmitEmail",
    value: function onSubmitEmail() {
      var back = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var business = this.props.business;
      var name = business.name;
      var email = this.state.email;

      if (back) {
        this.setState({
          emailSubmitted: false
        });
      } else {
        this.setState({
          emailSubmitted: true
        });
        (0, _EmailSubmitService["default"])({
          businessName: name,
          email: email
        });
      }

      this.logEvent('Email Submitted');
    }
  }, {
    key: "logEvent",
    value: function logEvent(step) {
      var business = this.props.business;

      _reactGa["default"].event({
        category: 'Checkout',
        action: "Step ".concat(step),
        label: business.name
      });
    }
  }, {
    key: "renderHasExistingDomain",
    value: function renderHasExistingDomain() {
      var _this4 = this;

      var collectEmail = this.props.collectEmail;
      var _this$state = this.state,
          enteredDomain = _this$state.enteredDomain,
          customDomainInputError = _this$state.customDomainInputError;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "domain-back-button",
        className: "back-button",
        style: {
          cursor: 'inherit'
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, null), "Step ", collectEmail ? '1/5' : '1/4'), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header centered-content"
      }, "Enter your custom domain"), /*#__PURE__*/_react["default"].createElement("p", {
        className: "modal-subheader centered-content body-text blue-color"
      }, "Connect your custom domain to your new site"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, {
        className: "modal-body"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        className: "domain-search-input domain-search-input-full-width custom-domain-input",
        type: "text",
        placeholder: "mydomain.com",
        action: true,
        labelPosition: "left",
        value: enteredDomain,
        onChange: this.handleDomainChange
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Label, {
        className: "https-label domain-search-input-consistent-padding"
      }, "https://"), /*#__PURE__*/_react["default"].createElement("input", {
        className: "borderless-input domain-search-input-consistent-padding"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "domain-connect-button",
        className: "domain-search-button centered-button",
        type: "submit",
        onClick: function onClick() {
          return _this4.onCustomDomainSelected(enteredDomain);
        }
      }, "Connect")), customDomainInputError && /*#__PURE__*/_react["default"].createElement("p", {
        className: "error-message"
      }, "Please enter a valid domain."), /*#__PURE__*/_react["default"].createElement("p", {
        className: "modal-subheader body-text blue-color"
      }, "Please allow 2-3 business days to process and connect your custom domain to your new published site"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "custom-domain-connect-button",
        className: "publish-now-from-request-button extra-margin centered-content blue-color",
        onClick: this.onHasCustomDomainChanged
      }, "I want to search for a new domain."))));
    }
  }, {
    key: "renderDomainSearch",
    value: function renderDomainSearch() {
      var _this$props = this.props,
          defaultDomain = _this$props.defaultDomain,
          collectEmail = _this$props.collectEmail;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "domain-back-button",
        className: "back-button",
        style: {
          cursor: 'inherit'
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, null), "Step ", collectEmail ? '1/5' : '1/4'), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header centered-content"
      }, "Search for a custom domain for your site"), /*#__PURE__*/_react["default"].createElement("p", {
        className: "modal-subheader centered-content body-text blue-color"
      }, "Your domain will be your website\u2019s URL address"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, {
        className: "modal-body"
      }, /*#__PURE__*/_react["default"].createElement(_DomainSearchForm["default"], {
        defaultDomain: defaultDomain,
        onDomainSelected: this.onDomainSelected,
        onHasCustomDomainChanged: this.onHasCustomDomainChanged
      })));
    }
  }, {
    key: "renderSubmitEmail",
    value: function renderSubmitEmail() {
      var _this5 = this;

      var email = this.state.email;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "checkout-back-button",
        className: "back-button",
        onClick: function onClick() {
          return _this5.onCustomDomainSelected(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "caret left"
      }), "Step 2/5"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header"
      }, "Please submit your email."), /*#__PURE__*/_react["default"].createElement("p", {
        className: "modal-subheader centered-content body-text blue-color"
      }, "We'll use this to contact you about updates to your website."), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, {
        className: "email-submission-container"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: email,
        onChange: this.handleEmailChange,
        placeholder: "Your Email"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        onClick: function onClick() {
          return _this5.onSubmitEmail(false);
        }
      }, "Submit")));
    }
  }, {
    key: "renderPaymentOptions",
    value: function renderPaymentOptions() {
      var _this6 = this;

      var collectEmail = this.props.collectEmail;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "checkout-back-button",
        className: "back-button",
        onClick: function onClick() {
          return collectEmail ? _this6.onSubmitEmail(true) : _this6.onCustomDomainSelected(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "caret left"
      }), "Step ", collectEmail ? '3/5' : '2/4'), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header"
      }, "Let's finalize your site!"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react["default"].createElement(_PaymentOptions["default"], {
        onPlanSelected: this.onPlanSelected
      })));
    }
  }, {
    key: "renderPeriodSelection",
    value: function renderPeriodSelection() {
      var _this7 = this;

      var collectEmail = this.props.collectEmail;
      var currentPlanIndex = this.state.currentPlanIndex;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "checkout-back-button",
        className: "back-button",
        onClick: function onClick() {
          return _this7.onPlanSelected(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "caret left"
      }), "Step ", collectEmail ? '4/5' : '3/4'), /*#__PURE__*/_react["default"].createElement(_PeriodSelect["default"], {
        currentPlanIndex: currentPlanIndex,
        onPeriodSelected: this.onPeriodSelected
      }));
    }
  }, {
    key: "renderCheckoutForm",
    value: function renderCheckoutForm() {
      var _this8 = this;

      var _this$state2 = this.state,
          currentPlanIndex = _this$state2.currentPlanIndex,
          currentPlanPeriod = _this$state2.currentPlanPeriod,
          currentDomain = _this$state2.currentDomain,
          customDomain = _this$state2.customDomain,
          email = _this$state2.email;
      var _this$props2 = this.props,
          business = _this$props2.business,
          onCheckoutCompleted = _this$props2.onCheckoutCompleted,
          collectEmail = _this$props2.collectEmail;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "checkout-back-button",
        className: "back-button",
        onClick: function onClick() {
          return _this8.onPeriodSelected(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "caret left"
      }), "Step ", collectEmail ? '5/5' : '4/4'), /*#__PURE__*/_react["default"].createElement(_reactStripeElements.StripeProvider, {
        apiKey: this.stripeApiKey
      }, /*#__PURE__*/_react["default"].createElement(_reactStripeElements.Elements, null, /*#__PURE__*/_react["default"].createElement(_CheckoutForm["default"], {
        email: email,
        business: business,
        currentPlanIndex: currentPlanIndex,
        isAnnual: currentPlanPeriod,
        onCheckoutCompleted: onCheckoutCompleted,
        currentDomain: currentDomain,
        customDomain: customDomain
      }))));
    }
  }, {
    key: "renderCompletion",
    value: function renderCompletion() {
      this.logEvent('Publish Completion');
      var handlePublishClose = this.props.handlePublishClose;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Completion["default"], {
        title: "Payment Complete",
        description: "A confirmation email will be sent to you shortly"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        className: "payment-publish-button centered-button extra-margin",
        onClick: handlePublishClose
      }, "View published site"));
    }
  }, {
    key: "renderAdvancedCompletion",
    value: function renderAdvancedCompletion() {
      this.logEvent('Publish Advanced Plan Completion');
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Completion["default"], {
        title: "Advanced Payment Selected",
        description: "A confirmation email will be sent to you shortly"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          currentDomain = _this$state3.currentDomain,
          hasCustomDomain = _this$state3.hasCustomDomain,
          currentPlanIndex = _this$state3.currentPlanIndex,
          currentPlanPeriod = _this$state3.currentPlanPeriod,
          emailSubmitted = _this$state3.emailSubmitted;
      var _this$props3 = this.props,
          showPublishModal = _this$props3.showPublishModal,
          handlePublishOpen = _this$props3.handlePublishOpen,
          handlePublishClose = _this$props3.handlePublishClose,
          checkedOut = _this$props3.checkedOut,
          collectEmail = _this$props3.collectEmail;
      var modalBody;

      if (!checkedOut && currentDomain === null) {
        modalBody = hasCustomDomain ? this.renderHasExistingDomain() : this.renderDomainSearch();
      }

      if (!checkedOut && currentDomain !== null && currentPlanPeriod === null) {
        modalBody = currentPlanIndex === null ? this.renderPaymentOptions() : this.renderPeriodSelection();
      }

      if (!emailSubmitted && currentDomain !== null && collectEmail) {
        modalBody = this.renderSubmitEmail();
      }

      if (!checkedOut && currentDomain !== null && (currentPlanIndex === null || currentPlanIndex < _paymentTypes.CUSTOM_PLAN_INDEX) && currentPlanPeriod !== null) {
        modalBody = this.renderCheckoutForm();
      }

      if (checkedOut) {
        modalBody = currentPlanIndex === _paymentTypes.CUSTOM_PLAN_INDEX ? this.renderAdvancedCompletion() : this.renderCompletion();
      }

      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
        trigger: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          id: "publish-now-button",
          className: "payment-publish-button"
        }, "Sign Up"),
        className: "modal-container",
        open: showPublishModal,
        dimmer: "inverted",
        onOpen: handlePublishOpen,
        onClose: handlePublishClose
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "inside-close-icon",
        className: "inside-close-icon",
        onClick: handlePublishClose,
        icon: true
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "close"
      })), modalBody);
    }
  }]);
  return PublishModal;
}(_react["default"].Component);

exports["default"] = PublishModal;